import {IconButton} from '@primer/react'
import {SearchIcon} from '@primer/octicons-react'
import {useFilter} from '../context'

export const SubmitButton = () => {
  const {onSubmit} = useFilter()
  return (
    <IconButton
      aria-label="Search"
      size="medium"
      icon={SearchIcon}
      variant="default"
      onClick={onSubmit}
      sx={{
        color: 'fg.muted',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        flexShrink: 0,
        boxShadow: 'none',
        ':focus': {
          zIndex: 1,
        },
      }}
    />
  )
}

try{ SubmitButton.displayName ||= 'SubmitButton' } catch {}